<template>
  <div class="data-contant">
    <ul>
      <li
        v-for="(item, index) in list"
        :key="index"
      >
        <p :class="['info-name',index < 3?'more-margin':'']">{{ item.name }}</p>
        <p
          :class="['data-price',index < 3?'more-margin':'']"
          v-if="index < 3"
        >{{ item.value }}</p>
        <p
          :class="['data-rate',item.type == 'up' ? 'data-up' : 'data-down']"
          v-if="index < 3"
          class="change"
        >
          <span>{{ item.change }}</span>
          <span>({{ item.netChange }})</span>
        </p>
        <p
          :class="['data-price',item.sh > 0 ? 'data-up':'data-down']"
          v-if="index > 2"
        >
          <span>{{ item.sh ? item.sh : '----' }} {{ $t('index-data.yi') }}</span>
          <span class="dataType">（{{ $t('index-data.hu') }}）</span>
        </p>
        <p
          :class="['data-ratio',item.sz > 0 ? 'data-up' : 'data-down']"
          v-if="index > 2"
        >
          <span>{{ item.sz ? item.sz : '----' }} 亿</span>
          <span class="dataType">（{{ $t('index-data.shen') }}）</span>
        </p>
      </li>
    </ul>
  </div>
</template>
<script>
import * as api from "~/api/index";

export default {
  name: "index-data",
  data() {
    return {
      list: [],
      timeInterval: null
    };
  },
  methods: {
    async getData() {
      let rsp = await this.$axios(api.getHomeData());
      this.list = rsp.result;
      this.list.forEach((item, idx) => {
        if (idx < 3) {
          item.netChange = (item.netChange * 100).toFixed(2) + "%";
          if (item.change > 0) {
            item.change = "+" + item.change;
            item.type = "up";
          } else {
            item.type = "down";
          }
        } else {
          item.sh = (item.sh / 100000000).toFixed(2);
          item.sz = (item.sz / 100000000).toFixed(2);
        }
      });
    }
  },
  created() {
    clearInterval(this.timeInterval);
  },
  mounted() {
    this.timeInterval = setInterval(() => {
      this.getData();
    }, 30000);
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.timeInterval);
  }
};
</script>
<style scoped lang="less">
.data-contant {
  margin-bottom: 20px;
  background-color: #fff;
  ul {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    /* padding: 20px; */
    height: 80px;
    li {
      width: 19%;
      overflow: hidden;
      padding: 0 20px;
      padding-left: 12px;
      display: inline-block;
      &:not(:last-child) {
        border-right: 1px solid #e8e8e8;
      }
      .info-name {
        font-size: 14px;
        margin-bottom: 8px;
      }
      .more-margin {
        margin-bottom: 9px;
      }
      .data-price {
        margin-bottom: 7px;
        font-size: 14px;
        font-weight: bold;
      }
      .more-margin {
        margin-bottom: 8px;
      }
      .data-rate {
        font-size: 14px;
      }
      .data-ratio {
        font-size: 14px;
        font-weight: bold;
      }
      .data-up {
        color: rgb(255, 90, 90);
      }
      .data-down {
        color: rgb(102, 208, 150);
      }
      .dataType {
        color: #000;
      }
      .change {
        display: flex;
        justify-content: space-between;
      }
    }
  }
}
</style>
